import { NextSeo } from 'next-seo'

const Meta = () => {
  return (
    <NextSeo
      title='Programs'
      description='All the programs offered on Thrive Cafe'
    />
  )
}

export default Meta
